// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".v-icon{display:inline-block;position:relative}.v-icon svg{bottom:0;height:100%;left:0;position:absolute;right:0;top:0;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
